import { render, staticRenderFns } from "./PaymentRecordHandler.vue?vue&type=template&id=6c53e874&scoped=true"
import script from "./PaymentRecordHandler.vue?vue&type=script&lang=ts"
export * from "./PaymentRecordHandler.vue?vue&type=script&lang=ts"
import style0 from "./PaymentRecordHandler.vue?vue&type=style&index=0&id=6c53e874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53e874",
  null
  
)

export default component.exports